// extracted by mini-css-extract-plugin
export var page = "Page-module--page--24e03";
export var relatedPages = "Page-module--relatedPages--0833a";